import React from "react";
import { FaShieldAlt, FaRegClock, FaHandshake, FaUserTie, FaMapMarkedAlt } from "react-icons/fa";
import { HiOutlineReceiptRefund } from "react-icons/hi2";

const points = [
  { title: "ICAI Certified Professionals", desc: "Work handled by qualified, accountable CA experts.", icon: FaUserTie },
  { title: "Transparent Pricing", desc: "Clear scope and pricing—no hidden surprises later.", icon: HiOutlineReceiptRefund },
  { title: "On-Time Compliance", desc: "Timely filing reminders and structured execution.", icon: FaRegClock },
  { title: "Dedicated CA Support", desc: "One point of contact. WhatsApp-friendly updates.", icon: FaHandshake },
  { title: "PAN-India Services", desc: "Remote-first process for clients across India.", icon: FaMapMarkedAlt },
  { title: "Trust & Data Security", desc: "Confidential handling of documents and records.", icon: FaShieldAlt }
];

export default function WhyChooseUs() {
  return (
    <section id="why" className="section bg-navy-50/70">
      <div className="mx-auto max-w-7xl container-pad">
        <h2 className="section-title">Why Choose Us</h2>
        <p className="section-subtitle">
          Built for Indian clients who value clarity, trust, and speed. We keep the process simple—mostly on WhatsApp—with reliable documentation and timelines.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {points.map((p) => (
            <div key={p.title} className="card p-6">
              <div className="flex items-start gap-4">
                <div className="h-12 w-12 rounded-2xl bg-white flex items-center justify-center border border-navy-900/5">
                  <p.icon className="text-navy-900" size={22} />
                </div>
                <div>
                  <h3 className="font-heading text-lg text-navy-900">{p.title}</h3>
                  <p className="mt-1 text-sm text-navy-800/75">{p.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 grid gap-4 lg:grid-cols-3">
          <div className="card p-6 lg:col-span-2">
            <div className="font-heading text-xl text-navy-900">What you get with us</div>
            <ul className="mt-3 grid gap-2 text-sm text-navy-800/80">
              <li>• Clear checklist + timeline before starting</li>
              <li>• Status updates on WhatsApp</li>
              <li>• Proper documentation for future audits/notices</li>
              <li>• Practical advice—not complicated jargon</li>
            </ul>
          </div>
          <div className="card p-6 bg-navy-900 text-white">
            <div className="font-heading text-xl">Need help today?</div>
            <p className="mt-2 text-sm text-white/85">Tap below for a free consultation—get a clear next step in minutes.</p>
            <a href="#contact" className="mt-4 inline-flex w-full items-center justify-center rounded-xl bg-gold-500 px-5 py-3 font-semibold text-navy-900 transition hover:opacity-95">
              Book Free Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
